import { render, staticRenderFns } from "./VersionHistoryList.vue?vue&type=template&id=3a407811"
import script from "./VersionHistoryList.vue?vue&type=script&lang=js"
export * from "./VersionHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports